import {getPackageHistoryForAssociate} from "../../../../commons/api/GetPackageHistoryForAssociateResults";

export const getCompletePackageHistoryForAssociate = async (associateLoginId, startTime, endTime) => {
    let packageHistoryResult = await getPackageHistoryForAssociate(
        associateLoginId,
        100,
        null,
        startTime,
        endTime
    );
    let packageHistory = packageHistoryResult.packageRecordList;
    let nextPageToken = packageHistoryResult.nextPageToken;;
    while (nextPageToken) {
        let nextPageResult = await getPackageHistoryForAssociate(
            associateLoginId,
            100,
            nextPageToken,
            startTime,
            endTime
        );
        packageHistory = [...packageHistory, ...nextPageResult.packageRecordList]
        nextPageToken = nextPageResult.nextPageToken;
    }
    return packageHistory;
}


// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/GetPackageHistory.js